<div id="preview" #preview [ngClass]="{'full-screen': showFullScreen}"></div>
